module.exports = __webpack_public_path__ + "media/images/test_eb-18a2ace81ab027c627ed5dfa6374cee6.png";